import React, { useState } from 'react';
import {
    Box
} from '@mui/material';
import { FileManager } from './FileManager';

function HomePage({ mode, fileOperations, jobParameters, user, callApi }) {
    const [refreshFileList, setRefreshFileList] = useState(0);

    return (
        <>
            <Box component="hr" sx={{
                border: 'none',
                borderTop: '1px solid #ccc',
                margin: '1em 0'
            }} />

            <FileManager
                mode={mode}
                {...fileOperations}
                refreshTrigger={refreshFileList}
            />
        </>
    );
}

export default HomePage;
